<script lang="ts" setup>
import { type Text } from '@/utils/types/TextEditor'
import { type Image } from '@/utils/types/Image'
// #上文下圖
const props = defineProps({
  data: {
    type: Object
  }
})

const textData = ref()
const imgData = ref()

if (props.data) {
  const text: Ref<Text> = ref(props.data.text)
  const img: Ref<Image> = ref(props.data.image)
  textData.value = text.value
  imgData.value = img.value
}
</script>

<template>
  <div class="area">
    <div class="area__text" v-html="textData"></div>
    <figure class="area__pic">
      <Nimg :src="imgData?.link" :title="imgData?.title" :alt="imgData?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__title {
    text-align: center;
    font-weight: 500;
    font-size: toRem(28);
    margin-bottom: toRem(12);
  }

  &__pic {
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
